import { render, staticRenderFns } from "./PlatformFaq.vue?vue&type=template&id=3700eff7&"
import script from "./PlatformFaq.vue?vue&type=script&lang=js&"
export * from "./PlatformFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports